module.exports = __webpack_public_path__ + "static/media/kr.d4cf5da4.d4cf5da4.jpg";